import { createUseStyles } from 'react-jss';
import { defaultFonts, defaultBaseline } from '@wds/utils';

const useStylesGrid = createUseStyles((theme) => {
  const { breakpoints, grid } = theme;

  const gridGutter = (size) => (size ? grid.gutter[size] / -2 : 0);

  return {
    wrenchGridContainer: {
      ...defaultBaseline,
      ...defaultFonts(theme),
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginRight: 'auto',
      marginLeft: 'auto',
      [`@media (min-width: ${breakpoints.xs})`]: {
        maxWidth: grid.maxWidth.xs,
        paddingLeft: ({ noBleeds }) => !noBleeds && grid.bleed.xs,
        paddingRight: ({ noBleeds }) => !noBleeds && grid.bleed.xs,
      },
      [`@media (min-width: ${breakpoints.sm})`]: {
        maxWidth: ({ fluid }) => !fluid && grid.maxWidth.sm,
        paddingLeft: ({ noBleeds }) => !noBleeds && grid.bleed.sm,
        paddingRight: ({ noBleeds }) => !noBleeds && grid.bleed.sm,
      },
      [`@media (min-width: ${breakpoints.md})`]: {
        maxWidth: ({ fluid }) => !fluid && grid.maxWidth.md,
        paddingLeft: ({ noBleeds }) => !noBleeds && grid.bleed.md,
        paddingRight: ({ noBleeds }) => !noBleeds && grid.bleed.md,
      },
      [`@media (min-width: ${breakpoints.lg})`]: {
        maxWidth: ({ fluid }) => !fluid && grid.maxWidth.lg,
        paddingLeft: ({ noBleeds }) => !noBleeds && grid.bleed.lg,
        paddingRight: ({ noBleeds }) => !noBleeds && grid.bleed.lg,
      },
      [`@media (min-width: ${breakpoints.xl})`]: {
        maxWidth: ({ fluid }) => !fluid && grid.maxWidth.xl,
        paddingLeft: ({ noBleeds }) => !noBleeds && grid.bleed.xl,
        paddingRight: ({ noBleeds }) => !noBleeds && grid.bleed.xl,
      },
    },

    wrenchGrid: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      [`@media (min-width: ${breakpoints.xs})`]: {
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('xs'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('xs'),
      },
      [`@media (min-width: ${breakpoints.sm})`]: {
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('sm'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('sm'),
      },
      [`@media (min-width: ${breakpoints.md})`]: {
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('md'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('md'),
      },
      [`@media (min-width: ${breakpoints.lg})`]: {
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('lg'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('lg'),
      },
      [`@media (min-width: ${breakpoints.xl})`]: {
        paddingLeft: ({ noGutters }) => !noGutters && gridGutter('xl'),
        paddingRight: ({ noGutters }) => !noGutters && gridGutter('xl'),
      },
    },
  };
});

export default useStylesGrid;
